module.exports = __webpack_public_path__ + "img/03.7799c1c2.jpg";